<script setup lang="ts">
/**
 * La zona de peligro pasó a ser una pestaña del modo edición de Company:
 * borrar la cuenta es lo último que se le hace a una empresa, no una sección
 * que se visite. Esta ruta queda solo para no romper enlaces guardados.
 */
definePage({
  meta: { requiresAuth: true },
  redirect: { name: 'settings-company', query: { tab: 'danger' } },
});
</script>

<template>
  <div />
</template>
